<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="!isSettingLockoutSchedule" class="h-full w-full">
    <app-ag-grid class="mt-3" [gridOptions]="configGridOptions" [rowData]="configs" [hasFooter]="false"> </app-ag-grid>
  </div>
  <div *ngIf="isSettingLockoutSchedule" class="flex justify-center">
    <div class="p-field" style="width: 700px;">
      <label for="range">Range</label>
      <p-datepicker datepickerAmPmPatch [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" 
      inputId="range" [showTime]="true" [showClear]="true" (onClear)="clearLockoutSchedule()" [minDate]="minDate" />      
    </div>
  </div>


</ng-template>

<ng-template #footerTemplate>
  <div *ngIf="!isSettingLockoutSchedule" class="flex flex-row gap-2 mt-3 w-full">
    <button [disabled]="!uow.hasChanges()" (click)="save()" pButton type="button" class="p-button-raised">Save & Exit</button>
    <button [disabled]="!uow.hasChanges()" (click)="undo()" pButton type="button" class="p-button-raised">Undo Changes</button>
    <button (click)="close()" pButton type="button" class="p-button-raised">Close</button>
    <div class="grow"></div>
    <button (click)="editLockoutSchedule()" pButton type="button" class="p-button-raised">Edit Lockout Schedule</button>
  </div>
  <div *ngIf="isSettingLockoutSchedule" class="flex flex-row gap-2 mt-3 w-full">
    <button (click)="completeEditLockoutSchedule(true)" pButton type="button" class="p-button-raised">Ok</button>
    <button (click)="completeEditLockoutSchedule(false)" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
